import { render, staticRenderFns } from "./BookEdit.vue?vue&type=template&id=50f2e8f4&"
import script from "./BookEdit.vue?vue&type=script&lang=js&"
export * from "./BookEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports